<template>
    <div>
        <ynav title="查询结果"></ynav>
        <div v-if="id=='danger'">
            <div class="jieguo bgb pad30">
                <div class="yichang">
                    <h2>疫苗在召回范围内！</h2>
                    <p>建议您及时与当地疾控中心或接种单位进行咨询，了解后续处理措施！</p>
                </div>
                <div class="yimiao-main">
                    <h2>{{vaccine.NameCN}}</h2>
                    <p>全称：{{vaccine.AliasCN}}</p>
                    <p>生产企业：{{vaccine.CompanyName}}</p>
                    <p>生产批号：{{vaccine.CodeName}}</p>
                    <p>有效期至：{{vaccine.ExpiryDate}}</p>
                </div>
                <p>
                    <a class="chaxun" href="javascript:;" @click="$router.push({name:'Index'})">再次查询</a>
                </p>
            </div>
        </div>

        <div v-else-if="id=='clear'">
            <div class="jieguo bgb pad30">
                <div class="zhengchang">
                    <h2>请放心，该批次疫苗不在召回范围！</h2>
                </div>
                <div class="yimiao-main">
                    <h2>{{vaccine.NameCN}}</h2>
                    <p>全称：{{vaccine.AliasCN}}</p>
                    <p>生产企业：{{vaccine.CompanyName}}</p>
                    <p>生产批号：{{vaccine.CodeName}}</p>
                    <p>有效期至：{{vaccine.ExpiryDate}}</p>
                </div>
                <p>
                    <a class="chaxun" href="javascript:;" @click="$router.push({name:'Index'})">再次查询</a>
                </p>
            </div>
        </div>

        <div v-else-if="id=='noresult'||!id">
            <div class="jieguo bgb pad30">
                <div class="no-result">
                    <p>未查询到结果</p>
                   
                </div> <div class="laiyuan no-result-tip">
                    <p>1.请检查批号是否输入正确</p>
                    <p>2.请检查疫苗名称/生产厂家是否选择正确</p>
                </div>
                <p>
                    <a class="chaxun" href="javascript:;" @click="$router.push({name:'Index'})">再次查询</a>
                </p>
            </div>
        </div>

        <div class="wid600">
            <div class="laiyuan ">
                <p>数据来源：中国食品药品检定研究院</p>
                <p>若有疑问可咨询当地疾控中心或接种单位</p>
            </div>
            <div class="bottominfo">
                <a href="#"><img src="../assets/images/logo.png"></a>
                <p>由39健康网技术提供</p>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from "../libs/api";
import ynav from "../components/nav";

export default {
  components: {
    ynav
  },
  data() {
    return {
      id: "",
      vaccine: {}
    };
  },
  methods: {
    init() {
      if (this.id != "noresult") {
        if (this.$store.state.result) {
          this.vaccine = this.$store.state.result;
        } else {
          this.$router.push({ name: "Index" });
        }
      }
    }
  },

  mounted() {
    this.id = this.$route.params.id || "noresult";
    this.init();
  }
};
</script>




// WEBPACK FOOTER //
// src/views/Result.vue